module.exports = __webpack_public_path__ + "img/Profile_Picture.8f53591b.jpeg";